<div class="wrapper__form container mt-5 mb-3 border__form">
    <div class="row">
        <div class="d-flex flex-row align-items-start">
            <img src="../../../../assets/img/file-alt.svg" alt="logo" class="img-ico-form" />
            <h2 class="mb-0"> 
                {{ nombreCompleto }} 
            </h2>
        </div>
    </div>
    <!--Formulario inicial-->
    <div style="margin-bottom: 4rem !important;">
        <app-form 
            [title]="vjiText['reorganizacion-ordinaria-insolvencia']['tipo_solicitante']"
            [fields]="tipoSolicitante" 
            (changedControl)="onSubmitTipoSolicitante($event)" 
            [withSubmitButton]="false">
        </app-form>
    </div>
    <div id="sociedades" *ngIf="formTipoSolicitante.get('tipoSolicitante')?.value == 'SOCIEDAD'">
        <app-validacion-judicial-sociedad 
        [nombreTipoSolicitante]="'SOCIEDAD'"
        [paises]="paises"
        [listaTiposDocumento]="listaTiposDocumento"
        [tramiteVji]="tramiteVji"
        (formVjiOutput)="getFormJuridica($event)">
        </app-validacion-judicial-sociedad>
    </div>
    <!-- <div id="sucursales" *ngIf="formTipoSolicitante.get('tipoSolicitante')?.value == 'SUC_EXTRANJERA'">
        <app-validacion-judicial-sucursales 
        [idTipoSolicitante]="'SUC_EXTRANJERA'"
        [paises]="paises"
        [listaTiposDocumento]="listaTiposDocumento"
        [tramiteVji]="tramiteVji">
        </app-validacion-judicial-sucursales>
    </div> -->
</div>